import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import "./FCMTokenModal.css";

const FCMTokenModal = ({ dismiss, desvincular }) => {
  const { dispositivoPacienteState, textosState } = useContext(PortalContext);
  const dispositivoRegistrado = dispositivoPacienteState?.dispositivoPaciente?.data;

  // Textos personalizables desde la base de datos
  const txtHeader =
    textosState.textos.data?.msjDispositivoVinculado
      ? `${textosState.textos.data.msjDispositivoVinculado.nombre}: ${dispositivoRegistrado?.descripcion || "Dispositivo anterior"}`
      : `Dispositivo vinculado: ${dispositivoRegistrado?.descripcion || "Dispositivo anterior"}`;

  const txtBody = textosState.textos.data?.msjDispositivoVinculado
    ? textosState.textos.data.msjDispositivoVinculado.descripcion
    : "Ya tienes un dispositivo vinculado a tu cuenta. ¿Deseas revincular este dispositivo?";

  return (
    <div className="ptur-fcmtokenmodal-container">
      <div className="ptur-fcmtokenmodal-header c-white">
        <span className="rb18m">{txtHeader}</span>
      </div>
      <div className="ptur-fcmtokenmodal-body">
        <span>{txtBody}</span>
        <div className="ptur-fcmtokenmodal-botones">
          <div
            className="btn ptur-fcmtokenmodal-btnPrimary c-white rb18m pointer"
            onClick={desvincular}
          >
            Revincular
          </div>
          <div
            className="btn ptur-fcmtokenmodal-btnSecondary c-white rb18m pointer"
            onClick={dismiss}
          >
            Cerrar
          </div>
        </div>
      </div>
    </div>
  );
};

export default FCMTokenModal;
